import React, { useRef, useState, useEffect } from "react";
import "../../assets/css/Dashboard.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import Attendance from "./Attendance";
// Register the necessary components with ChartJS
import { Chart } from "react-google-charts";



function Dashboard() {
  const [branched, setbranched] = useState([]);
  const [today, settoday] = useState([]);
  const [paidTodayCount, setPaidTodayCount] = useState(0);
  const [overduedate, setoverduedate] = useState(0);
  const [selectedBranch, setSelectedBranch] = useState(() => localStorage.getItem("branch_id") || "");
  // walkin count
  const [walkincount, setwalkincount] = useState(0);
  const [getfollowups, setfollowups] = useState(0);
  // =================
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  // projecr  chart///////////////////////////////////////////////////
  // code to store the selected branch code
  const [selectedbranchcode, setslectedbranchcode] = useState(null);
  const [selectedbranchname, setselectedbranchname] = useState("All");
  const navigate = useNavigate();
  const clickLeads = () => {
    if (previllages.view) {
      navigate("/Enquiry");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickincome = () => {
    if (previllages.view) {
      navigate("/incomelist");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickexpense = () => {
    if (previllages.view) {
      navigate("/Expenselist");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickedcourses = () => {
    if (previllages.view) {
      navigate("/course");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickEntroll = () => {
    if (previllages.view) {
      navigate("/Studyingstudents");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickPendingFollowups = () => {
    if (previllages.view) {
      navigate("/Followups");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickfeedueFollowups = () => {
    if (previllages.view) {
      navigate("/Studyingstudents");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };

  const clickStudentDairy = () => {
    if (previllages.view) {
      navigate("/Studentdairy");
    } else {
      console.log("You do not have permission to view this page.");
      // Optionally, handle the case where the user doesn't have permission
    }
  };
  // =========================================Walkin====================================================
  useEffect(() => {
    walkin();
  }, [selectedBranch]);

  // useEffect(() => {
  //   fetchallbranch();
  //   fetchallfollowups();
  // }, []);

  useEffect(() => {
    fetchallbranch();
    fetchallfollowups();
  }, [selectedBranch]);


  const [admin, setadmin] = useState([]);

  const fetchallbranch = async () => {
    try {
      const response = await axios.get(apiUrl + "/walkin_Admin");
      console.log("Response from server walkin:", response.data);
      // setadmin(response.data);
      const matchedwalkin = response.data.branchCounts.find(item => item._id === selectedBranch);
      // setadmin(matchedwalkin);
      if (!matchedwalkin) {
        setadmin(response.data.branchCounts);
      }
      else {
        setadmin([matchedwalkin]);
      }

      console.log("The matchedwalkin is : ", matchedwalkin);
      console.log("The response.data.branchCounts is : ", response.data.branchCounts);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [followupscount, setfollowupscount] = useState([]);
  const fetchallfollowups = async () => {
    try {
      const response = await axios.get(apiUrl + "/Admin_followups");
      console.log("Response from server walkin:", response.data);
      setfollowupscount(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const walkin = async () => {
    try {

      const branch_id = selectedBranch || localStorage.getItem("branch_id") || null;

      const query = branch_id ? `?branch_id=${branch_id}` : "";

      const response = await axios.get(apiUrl + `/walkinleads_dashboard${query}`, {
        params: { branch_id },
      });

      console.log("Response from server:", response.data);
      setwalkincount(response.data.count);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // =========================================followups leads================================================
  useEffect(() => {
    followups();
  }, [selectedBranch]);

  const followups = async () => {
    try {
      const branch_id = selectedBranch || localStorage.getItem("branch_id") || null;
      const query = branch_id ? `?branch_id=${encodeURIComponent(branch_id)}` : "";

      const response = await axios.get(`${apiUrl}/followupsleads_dashboard${query}`);

      console.log("Response from server:", response.data);
      setfollowups(response.data.count);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // ===========================================today===========================================
  useEffect(() => {
    fetch();
  }, [selectedBranch]);

  const [todayInvoiceCounts, settodayInvoiceCounts] = useState({});
  const fetch = async () => {
    try {
      // const branch_id = selectedBranch || localStorage.getItem("branch_id") || null;
      let branch_id = null;
      const localStoragebranch_code = localStorage.getItem("branch_code")
      if (localStoragebranch_code != "All") {
        branch_id = localStoragebranch_code;
      }
      else {
        branch_id = selectedbranchcode;
      }
      const query = branch_id ? `?branch_id=${branch_id}` : "";
      // const response = await axios.get(apiUrl + `/invoice_details_today${query}`, {
      const response = await axios.get(apiUrl + `/invoice_details_today`, {
        params: { branch_id },
      });
      console.log("the branch_id in invoice_details_today : ", branch_id);
      console.log("invoice_details_today Response from server:", response.data);
      settoday(response.data.count);
      // Count occurrences of branch_name
      const today_branchCounts = response.data.invoices.reduce((acc, invoice) => {
        acc[invoice.branch_name] = (acc[invoice.branch_name] || 0) + 1;
        return acc;
      }, {});
      console.log("The today_branchCounts is : ", today_branchCounts);
      settodayInvoiceCounts(today_branchCounts);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // ================================overdue==========================================
  useEffect(() => {
    fetched();
  }, [selectedBranch]);
  const [branchInvoiceCounts, setBranchInvoiceCounts] = useState({});
  const fetched = async () => {
    try {
      let branch_id = null;
      const localStoragebranch_code = localStorage.getItem("branch_code")
      if (localStoragebranch_code != "All") {
        branch_id = localStoragebranch_code;
      }
      else {
        branch_id = selectedbranchcode;
      }
      console.log("the branch_id in fetch overdue function : ", branch_id);
      const query = branch_id ? `?branch_id=${branch_id}` : "";
      const response = await axios.get(apiUrl + `/invoice_details_overdue${query}`, {
        params: { branch_id },
      });
      console.log("Response data.count from server:", response.data);
      setoverduedate(response.data.count);
      // Count occurrences of branch_name
      const branchCounts = response.data.invoices.reduce((acc, invoice) => {
        acc[invoice.branch_name] = (acc[invoice.branch_name] || 0) + 1;
        return acc;
      }, {});
      console.log("the branchCounts is : ", branchCounts);
      setBranchInvoiceCounts(branchCounts);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // ===========================================role and previliages=====================================
  useEffect(() => {
    gettoken();
    getprevillages();
  }, []); // Empty dependency array means this effect runs once when the component is mounted
  const gettoken = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      setroleid(response.data.detail.rolename);
      localStorage.setItem("role_id", response.data.detail.rolename);
      const id = response.data.detail.rolename;
      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // Retrieve values from localStorage
  const branchId = localStorage.getItem("branch_id"); // Retrieve 'branch_id'
  const branchName = localStorage.getItem("branch_name"); // Retrieve 'branch_name'
  const empName = localStorage.getItem("emp_name"); // Retrieve 'emp_name'
  const getprevillages = () => {
    if (!branchId || branchName === "Branches" || !empName) {
      // Condition met: Enable privileges
      console.log("Condition met. Enabling privileges...");
      try {
        const userPrevillages = localStorage.getItem("user_previllages");
        // Check if user_previllages exists
        if (!userPrevillages) {
          throw new Error("user_previllages is not set in localStorage");
        }
        const username = JSON.parse(userPrevillages);
        // Check if modules exist in username
        if (!username?.modules || !Array.isArray(username.modules)) {
          throw new Error(
            "Modules are not defined or invalid in user_previllages"
          );
        }
        console.log(
          "User modules retrieved from localStorage:",
          username.modules
        );
        // Find the dashboard privileges
        const totalPrevilages = username.modules;
        const newEnquiry = totalPrevilages.find(
          (item) => item.name === "Dashboard"
        );
        // Check if newEnquiry and actions exist
        if (!newEnquiry?.actions) {
          throw new Error("No actions found for the 'dashboard' module");
        }
        console.log("The newEnquiry is:", newEnquiry.actions);
        // Call setprevillages with actions
        setprevillages(newEnquiry.actions);
      } catch (error) {
        console.error("Error in getprevillages:", error.message);
      }
    } else {
      // Condition not met: Do not enable privileges
      console.log("Condition not met. Privileges not enabled.");
    }
  };
  //=============================== code for new react-google-charts =========================================
  useEffect(() => {
    window.scrollTo(0, 0);
    fetch();
  }, []);
  const [getbranch, setbranch] = useState(
    localStorage.getItem("branch_id") || ""
  ); // Get branch_id from localStorage
  // ======================== code to get the leads years ===========================
  const [leadsyears, setleadsyears] = useState([]);
  const [selectedleadsYear, setSelectedleadsYear] = useState(new Date().getFullYear()); // Default to current year
  useEffect(() => {
    const leads_years = async () => {
      try {
        console.log("The leads_years function is called");
        // if (previllages.view) {
        const branch_id = localStorage.getItem("branch_id"); // Retrieve branch_id from localStorage
        // const query = branch_id ? `?branch_id=${branch_id}` : ""; // Add branch_id as query if exists
        const query = branch_id ? branch_id != "null" ? `?branch_id=${branch_id}` : "" : ""; // Add branch_id as query if exists
        const response = await axios.get(apiUrl + `/leads_dashboard_2${query}`);
        const data = response.data;
        console.log("The data in the leads_years : ", data);
        // Extract unique years
        const uniqueYears = [...new Set(data.map(item => item.year))];
        console.log("The data leads_years in the uniqueYears : ", uniqueYears);
        setleadsyears(uniqueYears);
        // setRevenueExpenseData(updatedData);
        // console.log("the updatedData in the bar chart is : ",updatedData);
        // } else {
        // If the user doesn't have the 'view' privilege, show an error or message
        console.log("You do not have permission to view this data.");
        // }
      } catch (error) {
        const branch_id = localStorage.getItem("branch_id"); // Retrieve branch_id from localStorage

        console.log("The branch_id in the leads_years catch block is : ", branch_id ? branch_id : "empty");

        console.error("Error fetching revenue and expense data:", error);
      }
    };
    leads_years();
  }, []);

  // ======================== code to get the leads years ===========================
  const [chartData, setChartData] = useState([["Category", "Leads", "Conversions"]]);
  const fetchLeadsData = async () => {
    try {
      const branch_id = localStorage.getItem("branch_id");
      // const query = branch_id ? `?branch_id=${branch_id}` : "";
      const query = branch_id ? branch_id != "null" ? `?branch_id=${branch_id}` : "" : "";
      // const response = await axios.get(apiUrl + `/leads_dashboard${query}`);
      const response = await axios.get(apiUrl + `/leads_dashboard_2${query}`);
      if (!response.data || response.data.length === 0) {
        console.warn("No data received for leads_dashboard.");
        return;
      }
      // code for filter the list based on the year
      const filteredData = response.data.filter(item => item.year === selectedleadsYear);
      // Formatting data correctly
      const formattedData = filteredData.map((monthData) => [
        // const formattedData = response.data.map((monthData) => [
        monthData.month, // Month already in "MMM YYYY" format
        monthData.totalLeads,
        monthData.totalConversions,
      ]);
      // console.log("The branch_id in the fetchLeadsData is : ",branch_id?branch_id : "empty");
      // console.log("the selectedleadsYear in the fetchLeadsData is : ",selectedleadsYear);
      // console.log("the response.data in the fetchLeadsData is : ",response.data);
      // console.log("the formattedData in the fetchLeadsData is : ",formattedData);
      setChartData([["Category", "Leads", "Conversions"], ...formattedData]);
    } catch (error) {
      console.error("Error fetching leads data:", error);
    }
  };

  const filter_fetchLeadsData = async (e) => {
    try {
      const selectedYear = parseInt(e.target.value); // Convert to number
      console.log("The filter_fetchLeadsData function is called", selectedYear);
      // setSelectedYear(selectedYear);
      setSelectedleadsYear(selectedYear);
      const branch_id = localStorage.getItem("branch_id");
      // const query = branch_id ? `?branch_id=${branch_id}` : "";
      const query = branch_id ? branch_id != "null" ? `?branch_id=${branch_id}` : "" : ""
      // const response = await axios.get(apiUrl + `/leads_dashboard${query}`);
      const response = await axios.get(apiUrl + `/leads_dashboard_2${query}`);
      if (!response.data || response.data.length === 0) {
        console.warn("No data received for leads_dashboard.");
        return;
      }
      const filteredData = response.data.filter(item => item.year === selectedYear);
      // Formatting data correctly
      const formattedData = filteredData.map((monthData) => [
        // const formattedData = response.data.map((monthData) => [
        monthData.month, // Month already in "MMM YYYY" format
        monthData.totalLeads,
        monthData.totalConversions,
      ]);
      // console.log("the selectedleadsYear in the filter_fetchLeadsData is : ",selectedleadsYear);
      // console.log("the filteredData in the filter_fetchLeadsData is : ",filteredData);
      // console.log("the response.data in the filter_fetchLeadsData is : ",response.data);
      // console.log("the formattedData in the filter_fetchLeadsData is : ",formattedData);
      setChartData([["Category", "Leads", "Conversions"], ...formattedData]);
    } catch (error) {
      console.error("Error fetching leads data:", error);
    }
  };
  useEffect(() => {
    fetchLeadsData();
  }, [selectedBranch])
  // ---------------------------------------------

  const chartOptions = {
    // title: 'Leads and Conversions (Last 6 Months)',
    chartArea: { width: "60%" },
    hAxis: {
      // title: "Month",
      minValue: 0,
    },
    pointSize: 10,
    vAxis: {
      title: "Number of Students",
    },
    bars: "horizontal", // Display bars horizontally
    colors: ["#850000", "#FDB304"], // Colors for the bars
    legend: { position: "bottom" },
  };

  //===================== code for double Bar chart ================================================
  //  State for selected branch
  const [revenueExpenseData, setRevenueExpenseData] = useState([
    ["Month", "Revenue", "Expense"],
  ]);
  console.log("the date revenue is ", revenueExpenseData)
  // =================
  const [branchbasedsss, setbranchbased] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentYear = new Date().getFullYear();
        console.log("the current year in the useeffect fatch data function : ", currentYear); // Example: 2025
        // Check if the user has the 'view' privilege
        // if (previllages.view) {
        const branch_id = localStorage.getItem("branch_id"); // Retrieve branch_id from localStorage
        // const query = branch_id ? `?branch_id=${branch_id}` : ""; // Add branch_id as query if exists
        const query = branch_id ? branch_id != "null" ? `?branch_id=${branch_id}` : "" : "";
        // const response = await axios.get(apiUrl + `/revenue_expense${query}`);
        const response = await axios.get(apiUrl + `/revenue_expense_final${query}`);
        const data = await response.data;
        console.log("the data was geting", data)
        console.log("the data was geting query", query)
        // Filter data by the selected year
        const filteredData = data.filter(item => item.year === selectedYear);
        console.log("the data was filter ", filteredData)
        // Define the last 6 months
        const updatedData = [["Month", "Revenue", "Expense"]];
        // data.forEach((item) => {
        filteredData.forEach((item) => {
          updatedData.push([item.month, item.revenue, item.expense]);
        });
        console.log("the data wassssssss", filteredData)
        setRevenueExpenseData(updatedData);
        console.log("the updatedData in the bar chart is : ", updatedData);
        // } else {
        // If the user doesn't have the 'view' privilege, show an error or message
        console.log("You do not have permission to view this data.");
        // }
      } catch (error) {
        console.error("Error fetching revenue and expense data:", error);
      }
    };
    fetchData();
    const branch_code = localStorage.getItem("branch_code");
    console.log("newdataconsole", branch_code)
    setbranchbased(branch_code)
    setTimeout(() => {
      const branch_code = localStorage.getItem("branch_code");
      setbranchbased(branch_code);
      console.log("newdataconsole", branch_code)
    }, 1000);
  }, [selectedBranch]); // Re-fetch data when branch changes
  // ============ code to get the revenue years ============================
  const [revenueyears, setrevenueyears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year
  useEffect(() => {
    const revenue_years = async () => {
      try {
        // Check if the user has the 'view' privilege
        // if (previllages.view) {
        const branch_id = localStorage.getItem("branch_id"); // Retrieve branch_id from localStorage
        // const query = branch_id ? `?branch_id=${branch_id}` : ""; // Add branch_id as query if exists
        const query = branch_id && branch_id !== "null" ? `?branch_id=${branch_id}` : "";
        // const response = await axios.get(apiUrl + `/revenue_expense${query}`);
        const response = await axios.get(apiUrl + `/revenue_expense_final${query}`);
        const data = response.data;
        console.log("The data in the revenue_years : ", data);
        // Extract unique years
        const uniqueYears = [...new Set(data.map(item => item.year))];
        console.log("The data in the uniqueYears : ", uniqueYears);
        setrevenueyears(uniqueYears);
        // // Define the last 6 months
        // const updatedData = [["Month", "Revenue", "Expense"]];
        // data.forEach((item) => {
        //   updatedData.push([item.month, item.revenue, item.expense]);
        // });
        // setRevenueExpenseData(updatedData);
        // console.log("the updatedData in the bar chart is : ",updatedData);
        // } else {
        // If the user doesn't have the 'view' privilege, show an error or message
        console.log("You do not have permission to view this data.");
        // }
      } catch (error) {
        console.error("Error fetching revenue and expense data:", error);
      }
    };
    revenue_years();
  }, []);
  // ========= code for get the weekly filter bar chart =========
  const filter_revenue_chart = async (e) => {
    try {
      const selectedYear = parseInt(e.target.value);
      setSelectedYear(selectedYear);
      const branch_id = localStorage.getItem("branch_id");

      const query = branch_id && branch_id !== "null" ? `?branch_id=${branch_id}` : "";
      const response = await axios.get(apiUrl + `/revenue_expense_final${query}`);
      const apiData = response.data;

      // 1. Create array of all months in order
      const allMonths = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];

      // 2. Initialize chart data with all months set to 0
      const chartData = allMonths.map(month => ({
        month,
        revenue: 0,
        expense: 0,
        year: selectedYear
      }));

      // 3. Merge API data into our initialized structure
      apiData.forEach(apiItem => {
        if (apiItem.year === selectedYear) {
          const foundMonth = chartData.find(item => item.month === apiItem.month);
          if (foundMonth) {
            foundMonth.revenue = apiItem.revenue || 0;
            foundMonth.expense = apiItem.expense || 0;
          }
        }
      });

      // 4. Format for chart (array of arrays)
      const updatedData = [
        ['Month', 'Revenue', 'Expense'],
        ...chartData.map(item => [item.month, item.revenue, item.expense])
      ];

      setRevenueExpenseData(updatedData);
      console.log("Final chart data:", updatedData);

    } catch (error) {
      console.error("Error fetching revenue and expense data:", error);
    }
  }
  // ============ code to set the branch code ========
  useEffect(() => {
    filter_revenue_chart();
  }, []);


  useEffect(() => {
    const handleStorageChange = () => {
      setbranchbased(localStorage.getItem("branch_code") || "");
      fetched();
      // console.log("The handleStorageChange function is called : ");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // ============ code to set the branch code ========
  // // Options for the chart
  // const double_bar_options = {
  //   // title: 'Active students per month',
  //   curveType: "function",
  //   legend: { position: "bottom" },
  //   pointSize: 10, // Add points on the line
  //   pointsVisible: true, // Ensure points are visible
  //   // colors: ['#FF5733', '#33C4FF'], // Custom colors for 2010 (orange) and 2020 (blue)
  //   colors: ["#850000", "#FDB304"], // Custom colors for 2010 (orange) and 2020 (blue)
  // };

  // const double_bar_options = {
  //   // title: 'Monthly Revenue & Expenses',
  //   legend: { position: "bottom" },
  //   // hAxis: { title: 'Month' },
  //   // vAxis: { title: 'Amount' },
  //   series: {
  //     0: { color: '#850000', targetAxisIndex: 0 }, // Revenue (left axis)
  //     1: { color: '#FDB304', targetAxisIndex: 1 }    // Expense (right axis)
  //   },
  //   vAxes: {
  //     // Left Y-axis (Revenue)
  //     0: {
  //       title: 'Revenue',
  //       titleTextStyle: { color: '#850000' }, // Matches Revenue color
  //       textStyle: { color: '#850000' } // Optional: axis labels color
  //     },
  //     // Right Y-axis (Expense)
  //     1: {
  //       title: 'Expense',
  //       titleTextStyle: { color: '#FDB304' }, // Matches Expense color
  //       textStyle: { color: '#FDB304' } // Optional: axis labels color
  //     }
  //   },

  // };

  const double_bar_options = {
    legend: { position: "bottom" },
    series: {
      0: { color: '#850000', targetAxisIndex: 0 }, // Revenue (left axis)
      1: { color: '#FDB304', targetAxisIndex: 0 }  // Changed expense to use the same axis index
    },
    vAxes: {
      // Main Y-axis (used for both series)
      0: {
        title: ' Amount of value ',
        titleTextStyle: { color: '#333333' },
        textStyle: { color: '#333333' },
        viewWindow: { min: 0 }, // Ensures the chart starts from zero
        gridlines: { count: 5 } // Controls number of gridlines/labels
      },
      // Dummy axis (not used by any series, but keeps the visual structure)
      1: {
        title: 'Expense',
        titleTextStyle: { color: '#FDB304' },
        textPosition: 'none',
        viewWindow: { min: 0 },
        gridlines: { count: 0, color: 'transparent' } // No gridlines for this axis
      }
    },
    bar: {
      groupWidth: '70%' // Controls the width of the bars
    }
  };

  // const double_bar_options = {
  //   legend: { position: "bottom" },
  //   series: {
  //     0: { color: '#850000', targetAxisIndex: 0 }, // Revenue (left axis)
  //     1: { color: '#FDB304', targetAxisIndex: 1 }  // Expense (right axis)
  //   },
  //   vAxes: {
  //     // Left Y-axis (Revenue)
  //     0: {
  //       title: 'Revenue',
  //       titleTextStyle: { color: '#850000' },
  //       textStyle: { color: '#850000' },
  //       viewWindow: {min: 0}, // Ensures the chart starts from zero
  //       gridlines: {count: 5} // Controls number of gridlines/labels
  //     },
  //     // Right Y-axis (Expense)
  //     1: {
  //       title: 'Expense',
  //       titleTextStyle: { color: '#FDB304' },
  //       textStyle: { color: '#FDB304' },
  //       textPosition: 'none', // This hides the number labels on the right axis
  //       viewWindow: {min: 0}, // Ensures the chart starts from zero
  //       gridlines: {count: 5} // Controls number of gridlines/labels
  //     }
  //   },
  //   bar: {
  //     groupWidth: '70%' // Controls the width of the bars
  //   },
  //   explorer: {
  //     actions: ['dragToZoom', 'rightClickToReset'],
  //     axis: 'vertical',
  //     keepInBounds: true
  //   }
  // };

  //===================== code for double Bar chart ================================================
  //=============================== code for new react-google-charts =========================================
  useEffect(() => {
    fetchbranch();
  }, []);
  const [branchnamelist, setbranchnamelist] = useState([]);
  const fetchbranch = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("branch data Response from server:", response.data);
      setbranched(response.data);
      // Extract branch_name and store separately
      const branchNamesList = response.data.map((item) => item.branch_name);
      // setBranchNames(branchNamesList);
      console.log("the branchNamesList is : ", branchNamesList)
      setbranchnamelist(branchNamesList);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    const storedBranch = localStorage.getItem("branch_id");
    if (storedBranch) {
      setSelectedBranch(storedBranch);
      setbranch(storedBranch); // Update the branch value in state
    }
  }, []);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const branchId = localStorage.getItem("branch_id");
    const branchName = localStorage.getItem("branch_name");

    if (branchId && branchId !== "null") {
      setSelectedBranch(branchId);
      setbranch(branchId); // Set initial branch
    }
  }, []); // Empty dependency array ensures this runs once on component mount

  const handleBranchChange = (e) => {

    const branch = e.target.value;
    console.log(e.target.value, "fffff")
    setSelectedBranch(branch);
    setbranch(branch);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    localStorage.setItem("branch_id", branch); // Update branch_id in localStorage
    console.log("The branched data in the handleBranchChange : ", branched);
    const matchedBranch = branched.find(item => item._id === e.target.value);
    console.log("The matchedBranch is : ", matchedBranch);
    if (!matchedBranch) {
      console.log("The matchedBranch is not present : ", matchedBranch);
      setslectedbranchcode(null);
    } else {
      console.log("The matchedBranch is present : ", matchedBranch.branch_id);
      setslectedbranchcode(matchedBranch.branch_id);
    }
    setselectedbranchname(e.target.value);
  };

  useEffect(() => {
    setSelectedBranch("");
    setbranch("");
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    localStorage.setItem("branch_id", ""); // Update branch_id in localStorage
  }, []); // Empty dependency array ensures this runs once on component mount

  const handlecallsClick = (brach) => {
    console.log("The handlecallsClick is called : ", brach);
    const branch_code = localStorage.getItem("branch_code");
    console.log("The branchId  is : ", branch_code != "All");
    if (branch_code != "All") {
      navigate("/Followups");
    }
    else {
      console.log("the management function call is called");
      navigate(`/Followups/${brach}`);
    }
  }

  const handlewall_in_click = (brach) => {
    console.log("The handlewall_in_click is called : ", brach);
    const branch_code = localStorage.getItem("branch_code");
    console.log("The branchId  is : ", branch_code != "All");
    if (branch_code != "All") {
      navigate("/Walkin");
    }
    else {
      console.log("the management function call is called");
      navigate(`/Walkin/${brach}`);
    }
  }

  const handle_invoice_click = (brach) => {
    console.log("The handlewall_in_click is called : ", brach);
    const branch_code = localStorage.getItem("branch_code");
    console.log("The branchId  is : ", branch_code != "All");

    if (branch_code != "All") {
      // navigate("/Invoice");
      navigate(`/Invoice/${brach}/Overdue`);
    }
    else {
      console.log("the management function call is called");
      navigate(`/Invoice/${brach}/Overdue`);
    }
  }

  const handle_invoice_today_click = (brach) => {
    console.log("The handlewall_in_click is called : ", brach);
    const branch_code = localStorage.getItem("branch_code");
    console.log("The branchId  is : ", branch_code != "All");

    if (branch_code != "All") {
      // navigate("/Invoice");
      navigate(`/Invoice/${brach}/Today`);
    }
    else {
      console.log("the management function call is called");
      navigate(`/Invoice/${brach}/Today`);
    }
  }

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div
        className="top"
        style={{
          background: "#f2f0f0",
          // background:"white",
          marginLeft: "0px",
          marginRight: "0px"
        }}
      >
        {/* <div className="row ">
          <div className="col-lg-3">
            {" "}
            <h5>
              <b>Dashboard</b>
            </h5>
          </div>
          <div className="col-lg-6"></div>
          <div className="col-lg-3 mt-1">

          </div>
        </div> */}
        {/* </div> */}
        {/* ================= DASHBOARD CARDS ================= */}
        {/* <div className="dashboard"> */}

          {/* ================= TOP SECTION ================= */}
          {/* <div className="row"> */}

            {/* ===== LEFT : DASHBOARD CARDS ===== */}
            {/* <div> */}

              {/* Row 1 */}
              <div className="row mb-2">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickLeads}>
                    <div className="card hello"><i className="fa-solid fa-graduation-cap iconcards"></i></div>
                    <h6 className="name">Leads</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickPendingFollowups}>
                    <div className="card hello"><i className="fa-solid fa-user-plus iconcards"></i></div>
                    <h6 className="name">Pending Payments</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickfeedueFollowups}>
                    <div className="card hello"><i className="fa-brands fa-readme iconcards"></i></div>
                    <h6 className="name">Fee Due</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickedcourses}>
                    <div className="card hello"><i className="fa-solid fa-toggle-on iconcards"></i></div>
                    <h6 className="name">Courses</h6>
                  </div>
                </div>
              </div>

              {/* Row 2 */}
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickEntroll}>
                    <div className="card hello"><i className="fa-solid fa-chalkboard-user iconcards"></i></div>
                    <h6 className="name">Enrollments</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickStudentDairy}>
                    <div className="card hello"><i className="fa-solid fa-hand-holding-dollar iconcards"></i></div>
                    <h6 className="name">Student Diary</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickincome}>
                    <div className="card hello"><i className="fa-solid fa-scale-unbalanced iconcards"></i></div>
                    <h6 className="name">Income</h6>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="card one" onClick={clickexpense}>
                    <div className="card hello"><i className="fa-solid fa-gears iconcards"></i></div>
                    <h6 className="name">Expense</h6>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== RIGHT : PENDING SUMMARY ===== */}

          {/* </div> */}

          {/* ================= CHART SECTION ================= */}
          <div className="row mt-2">

            <div className="col-lg-6">
              <div className="chart-header d-flex row mb-0">
                <div className="col-4"><h6>Leads & Conversions</h6></div>
                <div className="col-2"><select
                  className="form-select form-select-sm"
                  style={{ width: "80px" }}
                  value={selectedleadsYear}
                  onChange={filter_fetchLeadsData}
                >
                  {leadsyears.map(y => <option key={y}>{y}</option>)}
                </select>
                </div>
                <div className="col-5 d-flex justify-content-end" style={{ height: "36px"}}>
                  <div className="floating-label ms-3 me-0">
                    {branchbasedsss === "All" ? (
                      <select
                        style={{ height: "35px",width:"200px"}}
                        className="form-select"
                        value={selectedBranch}
                        onChange={handleBranchChange}
                        required
                      >
                        <option value="">All Branches</option>
                        {branched
                          .filter((item) =>
                            // ["Salem", "Chennai", "Trichy"].includes(item.branch_name)
                            branchnamelist.includes(item.branch_name)
                          ) // Filter for Salem, Chennai, or Trichy
                          .map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.branch_name}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <select
                        className="form-select"
                        value={selectedBranch}
                        onChange={handleBranchChange}
                        required
                      >
                        {(() => {
                          const branchId = localStorage.getItem("branch_id");
                          const selectedBranch = localStorage.getItem("branch_name"); // Get branch_name from localStorage
                          // console.log("the branchId in the else condition is : ",branchId);
                          if (!branchId || branchId === "null") {
                            // If branch_id is null, show only "All Branches"
                            return <option value="All Branches">All Branches</option>;
                          } else {
                            let filteredBranches = branched.filter((item) =>
                              // ["Salem", "Chennai", "Trichy"].includes(item.branch_name)
                              branchnamelist.includes(item.branch_name)
                            );
                            // If branch_name exists in localStorage, filter further
                            if (selectedBranch) {
                              filteredBranches = filteredBranches.filter(
                                (item) => item.branch_name === selectedBranch
                              );
                            }

                            return filteredBranches.length > 0 ? (
                              filteredBranches.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.branch_name}
                                </option>
                              ))
                            ) : (
                              <option value="all">All Branches</option>
                            );
                          }
                        })()}
                      </select>
                    )}
                  </div>
                </div>
              </div>

              <div className="card chart-card mt-0">
                <Chart
                  chartType="ColumnChart"
                  width="100%"
                  height="230px"
                  data={chartData}
                  options={chartOptions}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="chart-header d-flex">
                <h6>Revenue / Expense</h6>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "150px", marginLeft: "10px" }}
                  value={selectedYear}
                  onChange={filter_revenue_chart}
                >
                  {revenueyears.map(y => <option key={y}>{y}</option>)}
                </select>
              </div>

              <div className="card chart-card">
                <Chart
                  chartType="ColumnChart"
                  width="100%"
                  height="230px"
                  data={revenueExpenseData}
                  options={double_bar_options}
                />
              </div>
            </div>





            {/* ////////////// */}

            {/* <div className="row"> */}
            <div className="col-lg-6">
              <h5 className="">Pending Payment</h5>
            </div>
            <div className="col-lg-6">
              <h5 className="">Pending Followups</h5>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-6">
                  <div className="card p-3">
                    <h5 className="text-center bg-danger text-white p-3">
                      OverDue
                    </h5>
                    {/* <hr></hr> */}

                    {/* ==== this is the first code don't remove it =========== */}
                    {/* <div className="card">
                      <div className="row details-data">
                        <div className="col-lg-6 mt-1">
                          <b>{localStorage.getItem("branch_name")}</b>
                        </div>
                        <div className="col-lg-6 text-secondary">
                          <b> {overduedate}</b>
                        </div>
                      </div>
                    </div> */}
                    {/* ==== this is the first code don't remove it ========== */}

                    <div>
                      {/* {localStorage.getItem("branch_name") === "salem" || localStorage.getItem("branch_name") === "chennai" ? ( */}
                      {localStorage.getItem("branch_code") != "All" ? (
                        // This is the first code so don't remove it
                        // <div className="row details-data">
                        //   <div className="col-lg-6 mt-1">
                        //     <b>{localStorage.getItem("branch_name")}</b>
                        //   </div>
                        //   <div className="col-lg-6 text-secondary">
                        //   <b>{getfollowups || 0}</b>
                        //   </div>
                        // </div>
                        // This is the first code so don't remove it
                        branchInvoiceCounts ? (
                          <div className="row">
                            {Object.entries(branchInvoiceCounts)
                              .filter(([branch]) => branch === branchName)
                              .map(([branch, count]) => (
                                <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handle_invoice_click(branch)}>
                                  <div className="col-lg-6 mt-1">
                                    {branch}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {count}
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )

                      ) : (
                        // // Check if admin.branchCounts is defined, an array, and has at least one item
                        // // admin.branchCounts && Array.isArray(admin.branchCounts) && admin.branchCounts.length > 0 ? (
                        // followupscount.branches && Array.isArray(followupscount.branches) && followupscount.branches.length > 0 ? ( 
                        //  <div className="row">
                        //     {followupscount.branches.map((branch, index) => (
                        //       <div className=" details-data row" key={branch._id} style={{marginBottom: "7px"}}>
                        //         <div className="col-lg-6 mt-1">
                        //           {branch.branch_name}
                        //         </div>
                        //         <div className="col-lg-6 text-secondary">
                        //           {branch.lead_count}
                        //         </div>
                        //       </div>
                        //     ))}
                        //   </div>
                        // ) : (
                        //   <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        // )

                        branchInvoiceCounts ? (
                          <div className="row">
                            {Object.entries(branchInvoiceCounts)
                              .map(([branch, count]) => (
                                <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handle_invoice_click(branch)}>
                                  <div className="col-lg-6 mt-1">
                                    {branch}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {count}
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )
                      )}
                    </div>
                    {/* <div className="card mt-2">
                      <div className="row details-data">
                        <div className="col-lg-6 ">
                          <b>Erode</b>
                        </div>
                        <div className="col-lg-6 text-secondary">
               
                          <b>0</b>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card p-3">
                    <h5 className="text-center bg-danger text-white p-3">
                      Today
                    </h5>
                    {/* <hr></hr> */}

                    {/* ==== this is the first code don't remove it =========== */}
                    {/* <div className="card">
                      <div className="row details-data">
                        <div className="col-lg-6 mt-1">
                          <b>{localStorage.getItem("branch_name")}</b>
                        </div>
                        <div className="col-lg-6 text-secondary">
                          <b>{today}</b>
                        </div>
                      </div>
                    </div> */}
                    {/* ==== this is the first code don't remove it =========== */}
                    <div>
                      {localStorage.getItem("branch_code") != "All" ? (

                        todayInvoiceCounts ? (
                          <div className="row">
                            {Object.entries(todayInvoiceCounts)
                              .filter(([branch]) => branch === branchName)
                              .map(([branch, count]) => (
                                <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handle_invoice_today_click(branch)}>
                                  <div className="col-lg-6 mt-1">
                                    {branch}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {count}
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )

                      ) : (

                        todayInvoiceCounts ? (
                          <div className="row">
                            {Object.entries(todayInvoiceCounts)
                              .map(([branch, count]) => (
                                <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handle_invoice_today_click(branch)}>
                                  <div className="col-lg-6 mt-1">
                                    {branch}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {count}
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /======================================================pending followups============================================================= */}
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-6">
                  {/* <div className="card p-3" onClick={() => handlecallsClick("overall")}> */}
                  <div className="card p-3">
                    <h5 className="text-center bg-danger text-white p-3">
                      Calls
                    </h5>
                    {/* <hr></hr> */}

                    {/* ======== don't remove this code this is the first code  */}
                    {/* <div className="card">
                      <div className="row details-data">
                        <div className="col-lg-6 mt-1">
                          <b>{localStorage.getItem("branch_name")}</b>
                        </div>
                        <div className="col-lg-6 text-secondary">
                          <b>{getfollowups || 0}</b>
                        </div>
                      </div>
                    </div> */}
                    {/* ======== don't remove this code this is the first code  */}

                    {/* <div className="details-data"> */}
                    <div>
                      {/* {localStorage.getItem("branch_name") === "salem" || localStorage.getItem("branch_name") === "chennai" ? ( */}
                      {localStorage.getItem("branch_code") != "All" ? (
                        // This is the first code so don't remove it
                        // <div className="row details-data">
                        //   <div className="col-lg-6 mt-1">
                        //     <b>{localStorage.getItem("branch_name")}</b>
                        //   </div>
                        //   <div className="col-lg-6 text-secondary">
                        //   <b>{getfollowups || 0}</b>
                        //   </div>
                        // </div>
                        // This is the first code so don't remove it

                        followupscount.branches && Array.isArray(followupscount.branches) && followupscount.branches.length > 0 ? (
                          <div className="row">
                            {followupscount.branches
                              .filter((branch) => branch.branch_name === branchName)
                              .map((branch, index) => (
                                <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handlecallsClick(branch.branch_name)}>
                                  {/* <div className=" details-data row" key={branch._id} style={{marginBottom: "7px"}}> */}
                                  <div className="col-lg-6 mt-1">
                                    {branch.branch_name}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {branch.lead_count}
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )

                      ) : (
                        // Check if admin.branchCounts is defined, an array, and has at least one item
                        // admin.branchCounts && Array.isArray(admin.branchCounts) && admin.branchCounts.length > 0 ? (
                        followupscount.branches && Array.isArray(followupscount.branches) && followupscount.branches.length > 0 ? (
                          <div className="row">
                            {followupscount.branches.map((branch, index) => (
                              <div className=" details-data row" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handlecallsClick(branch.branch_name)}>
                                <div className="col-lg-6 mt-1">
                                  {branch.branch_name}
                                </div>
                                <div className="col-lg-6 text-secondary">
                                  {branch.lead_count}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card p-3">
                    <h5 className="text-center bg-danger text-white p-3">
                      Walk-in
                    </h5>
                    {/* <hr></hr> */}
                    {/* <div className="card"> */}
                    <div>
                      {/* <div className="row details-data">
                        <div className="col-lg-6 mt-1">
                          {admin.branchCounts[0]?.branch_name}
                        </div>
                        <div className="col-lg-6 text-secondary">
                          {admin.branchCounts[0]?.count}
                        </div>
                      </div> */}


                      {/* <div className="row details-data">
                        <div className="col-lg-6 mt-1">
                          <b>{localStorage.getItem("branch_name")}</b>
                        </div>
                        <div className="col-lg-6 text-secondary">
                          <b>{walkincount}</b>
                        </div>
                      </div>  */}
                      {/* <div className="details-data"> */}
                      <div>
                        {/* {localStorage.getItem("branch_name") === "salem" || localStorage.getItem("branch_name") === "chennai" ? ( */}
                        {localStorage.getItem("branch_code") != "All" ? (
                          // this is the first code so don't remove it 
                          // <div className="row details-data">
                          //   <div className="col-lg-6 mt-1">
                          //     <b>{localStorage.getItem("branch_name")}</b>
                          //   </div>
                          //   <div className="col-lg-6 text-secondary">
                          //     <b>{walkincount}</b>
                          //   </div>
                          // </div>
                          // this is the first code so don't remove it 

                          admin && Array.isArray(admin) && admin.length > 0 ? (
                            <div className="row">
                              {admin
                                .filter((branch) => branch.branch_name === branchName) // Filter based on localStorage value
                                .map((branch) => (
                                  <div className="row details-data" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handlewall_in_click(branch.branch_name)}>
                                    <div className="col-lg-6 mt-1">
                                      {branch.branch_name}
                                    </div>
                                    <div className="col-lg-6 text-secondary">
                                      {branch.count}
                                    </div>
                                  </div>
                                ))}
                            </div>

                            // This is working don't remove it 
                            // admin.branchCounts && Array.isArray(admin.branchCounts) && admin.branchCounts.length > 0 ? (
                            //   <div className="row">
                            //     {admin.branchCounts
                            //         .filter((branch) => branch.branch_name === branchName) // Filter based on localStorage value
                            //         .map((branch) => (
                            //           <div className="row details-data" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handlewall_in_click(branch.branch_name)}>
                            //             <div className="col-lg-6 mt-1">
                            //               {branch.branch_name}
                            //             </div>
                            //             <div className="col-lg-6 text-secondary">
                            //               {branch.count}
                            //             </div>
                            //           </div>
                            //         ))}
                            //   </div>
                          ) : (
                            <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                          )
                        ) : (
                          // Check if admin.branchCounts is defined, an array, and has at least one item
                          // admin.branchCounts && Array.isArray(admin.branchCounts) && admin.branchCounts.length > 0 ? (
                          //   <div className="row">
                          //     {admin.branchCounts.map((branch, index) => (
                          //       <div className="row details-data" key={branch._id} style={{marginBottom: "7px"}} onClick={() => handlewall_in_click(branch.branch_name)}>
                          //         <div className="col-lg-6 mt-1">
                          //           {branch.branch_name}
                          //         </div>
                          //         <div className="col-lg-6 text-secondary">
                          //           {branch.count}
                          //         </div>
                          //       </div>
                          //     ))}
                          //   </div>
                          admin && Array.isArray(admin) && admin.length > 0 ? (
                            <div className="row">
                              {admin.map((branch, index) => (
                                <div className="row details-data" key={branch._id} style={{ marginBottom: "7px" }} onClick={() => handlewall_in_click(branch.branch_name)}>
                                  <div className="col-lg-6 mt-1">
                                    {branch.branch_name}
                                  </div>
                                  <div className="col-lg-6 text-secondary">
                                    {branch.count}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>No branches available.</div>  // In case branchCounts is undefined, null, or empty
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        {/* </div> */}
        {/* <!-- Course Followups / Callback Card --> */}
      {/* </div> */}
      {/* <button onClick={handlecallsClick("aaa")}>this</button> */}
    </>
  );
}
export default Dashboard;